import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/img_30.png")